import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

// Aktivite izleme + otomatik çıkış
const IDLE_MS = 15 * 60 * 1000; // 15 dakika hareketsizlik
const COUNTDOWN_SEC = 10;
const EVENTS = ["mousemove", "keydown", "click", "touchstart", "scroll"];

export default function IdleTimeout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [countdown, setCountdown] = useState(COUNTDOWN_SEC);
  const timerRef = useRef(null);
  const countdownRef = useRef(null);

  const doLogout = async () => {
    setShowModal(false);
    if (countdownRef.current) clearInterval(countdownRef.current);
    await logout();
    navigate("/login");
  };

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setShowModal(true);
      setCountdown(COUNTDOWN_SEC);
    }, IDLE_MS);
  };

  useEffect(() => {
    if (!user) return;

    const handleActivity = () => {
      if (!showModal) resetTimer();
    };
    EVENTS.forEach((e) => window.addEventListener(e, handleActivity, { passive: true }));
    resetTimer();

    // Sekme kapama / yenileme uyarısı
    const beforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", beforeUnload);

    return () => {
      EVENTS.forEach((e) => window.removeEventListener(e, handleActivity));
      window.removeEventListener("beforeunload", beforeUnload);
      if (timerRef.current) clearTimeout(timerRef.current);
      if (countdownRef.current) clearInterval(countdownRef.current);
    };
    // eslint-disable-next-line
  }, [user, showModal]);

  useEffect(() => {
    if (!showModal) return;
    setCountdown(COUNTDOWN_SEC);
    countdownRef.current = setInterval(() => {
      setCountdown((c) => {
        if (c <= 1) {
          clearInterval(countdownRef.current);
          doLogout();
          return 0;
        }
        return c - 1;
      });
    }, 1000);
    return () => clearInterval(countdownRef.current);
    // eslint-disable-next-line
  }, [showModal]);

  const stayLoggedIn = () => {
    setShowModal(false);
    if (countdownRef.current) clearInterval(countdownRef.current);
    resetTimer();
  };

  return (
    <Dialog open={showModal} onOpenChange={() => {}}>
      <DialogContent className="max-w-md" onPointerDownOutside={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle>Devam Etmek İstiyor Musunuz?</DialogTitle>
        </DialogHeader>
        <div className="text-sm text-muted-foreground py-2">
          Bir süredir hareket algılanmadı. <b>{countdown} saniye</b> içinde otomatik çıkış yapılacak.
        </div>
        <div className="w-full bg-secondary rounded-full h-2 overflow-hidden">
          <div
            className="h-full bg-primary transition-all duration-1000"
            style={{ width: `${(countdown / COUNTDOWN_SEC) * 100}%` }}
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={doLogout} data-testid="idle-logout-btn">
            Çıkış Yap
          </Button>
          <Button onClick={stayLoggedIn} data-testid="idle-continue-btn">
            Devam Et
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
